var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:_vm.deanTableItemClass},[_c('dean-icon',{staticClass:"dean-table-item-icon",attrs:{"glyph":_vm.glyph,"height":_vm.height,"width":_vm.width}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }